<ng-container *ngIf="isOnline; else disconnected">
  {{score}}
</ng-container>
<ng-template #disconnected>
  -
</ng-template>

